module.exports = __webpack_public_path__ + "static/media/google_color.2c786f40.svg";